import { Row, Col } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import { Loader } from "components/Loader";
import { AccountContainer } from "./Account.styles";
import { userDetailSelect } from "Layout/slice/selector";

export const Account = () => {
  const userDetails = useSelector(userDetailSelect);

  return (
    <AccountContainer>
      <div className="profile-wrapper">
        {userDetails === null ? (
          <Loader />
        ) : (
          <div className="account">
            {/* Profile Name & Image Header */}

            <div className="profile-information">
              <Row>
                <Col xl={12} lg={12}>
                  <div className="content-wrapper">
                    <Outlet />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </div>
    </AccountContainer>
  );
};
